import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
    selector: 'app-round-progress-bar',
    templateUrl: './round-progress-bar.component.html',
    styleUrls: ['./round-progress-bar.component.scss'],
    standalone: false
})
export class RoundProgressBarComponent implements OnInit
{

  @ViewChild('ppc', { static: true }) private ppc: ElementRef;
  @ViewChild('ppcFill', { static: true }) private ppcFill: ElementRef;
  @Input() public value: number;
  @Input() public max: number;
  @Input() public description: string;

  constructor(private renderer: Renderer2)
  {
  }

  public ngOnInit(): void
  {
    const deg = 360 * this.value / 100;
    if (this.value > 50)
    {
      this.renderer.addClass(this.ppc.nativeElement, 'gt-50');
    }
    this.renderer.setStyle(this.ppcFill.nativeElement, 'transform', 'rotate(' + deg + 'deg)');
  }
}
